import axiosInstance from './axios-instance';
import type { AxiosResponse } from 'axios';

export const apiClient = {
    get: async <T>(endpoint: string): Promise<T> => {
        try {
            const response: AxiosResponse<T> = await axiosInstance.get<T>(endpoint);

            if (!response || response.data === undefined) {
                console.error('ERROR: Invalid response in apiClient.get!', response);
                throw new Error('Invalid response from axios');
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    },


    post: async <T>(endpoint: string, data?: unknown): Promise<T> => {
        const response: AxiosResponse<T> = await axiosInstance.post<T>(endpoint, data);
        return response.data;
    },

    patch: async <T>(endpoint: string, data: unknown): Promise<T> => {
        const response: AxiosResponse<T> = await axiosInstance.patch<T>(endpoint, data);
        return response.data;
    },

    put: async <T>(endpoint: string, data: unknown): Promise<T> => {
        const response: AxiosResponse<T> = await axiosInstance.put<T>(endpoint, data);
        return response.data;
    },

    delete: async <T>(endpoint: string, data?: unknown): Promise<T> => {
        const response: AxiosResponse<T> = await axiosInstance.delete<T>(endpoint, { data });
        return response.data;
    },
};

